import React, { Component } from 'react';
import './App.css';
import Noaa from './components/Noaa';

class App extends Component {
  
  render() {
    //picks random background image for the header
    const backgrounds = [require('./components/bg/background1.jpg'), require('./components/bg/background2.jpg'), require('./components/bg/background3.jpg'), require('./components/bg/background4.jpg')]
    const bg = Math.floor(Math.random() * 4);

      return (
        <div className="App">
          <header className="App-header" style={{backgroundImage: `url(${backgrounds[bg]})`}}>
            <h1 className="App-title">Dark Sky Weather</h1>
            <hr className="Header-HR"/>
            <div clasName="Nav-bar">
              <h4 className="App-subtitle"><em>Hurricane tracking hub</em></h4><h4 className="App-subtitle">&nbsp;|&nbsp;More projects at <a href="https://samdefazio.com" target="blank" className="App-subtitle">samdefazio.com</a></h4>
            </div>
          </header>

          <div className="NOAA">
            <Noaa />
          </div>

        </div>
      );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js